import { render, staticRenderFns } from "./AudioRecord.vue?vue&type=template&id=1492473c&scoped=true&"
import script from "./AudioRecord.vue?vue&type=script&lang=js&"
export * from "./AudioRecord.vue?vue&type=script&lang=js&"
import style0 from "./AudioRecord.vue?vue&type=style&index=0&id=1492473c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492473c",
  null
  
)

export default component.exports